"use strict";

module.exports = require("../dnd/dnd");



//////////////////
// WEBPACK FOOTER
// ./~/fine-uploader/lib/dnd.js
// module id = 38
// module chunks = 1